import { Utils } from "@/plugins/utils";
import router from '@/router';

export default {
	namespaced: true,
	state: {
		lstCvm: [],
		cvm: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false
	},
	getters: {

	},
	mutations: {
		set(state, cvm){
			state.cvm = cvm
			if (cvm)
				state.update = true
		},
		initForm(state){
			state.insert = false
			state.update = false
			state.cvm = null
		},
		setParamsDataTable(state, payload){
			state.lstCvm = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
	},
	actions: {
		initForm(store){
			store.commit("initForm")
		},
		async find(store, cvmgrupo){
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios.get(`/Oryx/OperationGroups/Find/${cvmgrupo}`)
			.then(response => {
				let cvm = Utils.ValidateAxiosResponse(response.data);
				store.commit("set", cvm)
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},
		save(store){
			if (store.state.update){
				store.dispatch("update")
				return
			}
			store.dispatch("insert")
		},
		async insert(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			let payload = await this._vm.$axios.post("/Oryx/OperationGroups/Insert", store.state.cvm )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/grupos-de-operacao")
				store.state.cvm = null
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async update(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			let payload = await this._vm.$axios.put("/Oryx/OperationGroups/Update", store.state.cvm )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/grupos-de-operacao")
				store.state.cvm = null
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async delete(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
			let payload = await this._vm.$axios.delete(`/Oryx/OperationGroups/Delete/${store.state.cvm.cvmgrupo}`)
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/grupos-de-operacao")
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async findList(store){
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios.get("/Oryx/OperationGroups/FindList")
			.then(response => {
				let lstCvm = Utils.ValidateAxiosResponse(response.data);
				store.state.lstCvm = lstCvm
				store.state.hasNext = lstCvm.length > store.state.itemsPerPage
				return true
			}).catch(error => {
				store.state.lstCvm = []
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			})
			store.state.loading = false
			return payload
		},
		async search(store, { limit = 20, page = 1 }) {
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios.get(`/Oryx/OperationGroups/Search?search=${store.state.search}&limit=${limit}&page=${page}`)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				store.commit("setParamsDataTable", payload)
				return true
			})
			.catch((error) => {
				store.state.lstCvm = []
				store.state.search = ""
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},
	}
}
